import { Button } from "@/components/ui/button";
import { Shield } from "lucide-react";

const MaintenanceSection = () => {
  return (
    <section className="py-16 border-t border-border" aria-labelledby="maintenance-title">
      <div className="container px-4 sm:px-6 lg:px-8">
        <div className="bg-secondary/50 border border-border ring-1 ring-white/[0.08] dark:ring-white/[0.12] rounded-2xl p-8 md:p-12 text-center animate-fade-in">
          <Shield className="w-12 h-12 text-primary mx-auto mb-6" />
          <h2 id="maintenance-title" className="text-2xl md:text-3xl font-bold mb-4">
            Keep Your Site Running Smoothly
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto mb-8">
            Maintenance plans that keep your site fast, secure, and up-to-date—so you can focus
            on your business.
          </p>
          <Button asChild size="lg">
            <a href="/services/maintenance">
              VIEW MAINTENANCE PLANS
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default MaintenanceSection;
